import { z } from 'zod';
import type { Simplify } from 'type-fest';

import type { ITimestamp } from '../../types/common';

export enum OIDCProviderScope {
  ORG = 'org',
  TEAM = 'team',
}

export type OIDCProvider = {
  id: number;
  organizationId: number;
  issuer: string;
  scope: OIDCProviderScope;
  scopeId: number;
} & ITimestamp;

export type OIDCProviderWithTeamName = Simplify<(Omit<OIDCProvider, 'scope'> & {
  scope: OIDCProviderScope.ORG;
  teamName?: null;
}) | (Omit<OIDCProvider, 'scope'> & {
  scope: OIDCProviderScope.TEAM;
  teamName: string;
})>;

export const NewOIDCProviderValidator = z.discriminatedUnion('scope', [
  z.object({
    scope: z.literal(OIDCProviderScope.ORG),
    issuer: z.string(),
  }),
  z.object({
    scope: z.literal(OIDCProviderScope.TEAM),
    scopeId: z.number(),
    issuer: z.string(),
  }),
]);
